import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "block w-full h-60" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = { class: "error-msg" }

import {computed, onMounted, ref, toRef} from "vue";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import {CategoryInfo} from "@/models/category/CategoryInfo";
import {CategoryService} from "@/utilities/services/entities/CategoryService";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import MultiSelect from "@/components/inputs/MultiSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryEditor',
  props: {
  data: Object
},
  setup(__props) {

const props = __props

const globalStore = useGlobalStore();
const { t } = useI18n();
const categoryService = new CategoryService();

const availableIcons = ref<any>(null);
const allIcons = ref<Array<string>|null>(null);


const popupData = toRef<CategoryInfo>(props, 'data');

const rules = computed(() => {
  return {
    title: { required: helpers.withMessage(t('validators.required'), required), },
    iconName: { required: helpers.withMessage(t('validators.required'), required), },
  }
})

const v$ = ref(useVuelidate(rules, popupData))

const setSelectedIcon = async()=>{
  // get all icons to find currently selected (if there is one selected)
  allIcons.value = await categoryService.getAllIconNames(ErrorLocationType.popup);

  // get available icons
  availableIcons.value = await categoryService.getAvailableIconNames(ErrorLocationType.popup);

  // add selected icon to available ones
  if (!NullOrUndefinedHelper(popupData.value.iconName)) availableIcons.value?.push(popupData.value.iconName);
}

onMounted(async() => {
  //@ts-expect-error
  globalStore.modal.validator = v$;
  globalStore.modal.bigMode = true;

  await setSelectedIcon();
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('popups.categoryEditor.titleName')) + " * ", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.title.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupData).title) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, _unref(popupData).title]
              ]),
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.title.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('popups.categoryEditor.iconName')) + " * ", 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.iconName.$errors.length })
            }, [
              _createVNode(MultiSelect, {
                selected: _unref(popupData).iconName,
                options: availableIcons.value,
                mode: "single",
                icon: true,
                onSelectChanged: _cache[1] || (_cache[1] = (value)=>{_unref(popupData).iconName = value})
              }, null, 8, ["selected", "options"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.iconName.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}
}

})